module.exports = __webpack_public_path__ + "img/bank.f176aa75.svg";